import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/UserReports.css';


const UserReports = () => {
    const [reports, setReports] = useState([]);
    const [error, setError] = useState('');
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


    useEffect(() => {
        const fetchReports = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setError('User not logged in');
                    return;
                }

                const response = await axios.get(`${API_BASE_URL}/user/reports`, {
                    headers: { 'Authorization': `Bearer ${token}` },
                });

                if (response.data && Array.isArray(response.data)) {
                    setReports(response.data);
                } else {
                    setError('No reports found');
                }
            } catch (error) {
                setError('Failed to fetch reports');
            }
        };

        fetchReports();
    }, []);

    return (
        <div className="user-reports-section">
            <h2>Your Reports</h2>
            {error ? (
                <p className="error">{error}</p>
            ) : (
                <>
                    {reports.length === 0 ? (
                        <p className="empty-state">No reports submitted.</p>
                    ) : (
                        <ul className="report-cards">
                            {reports.map((report) => (
                                <li key={report.id} className="report-card">
                                    <h4 className="report-title">{report.subject}</h4>
                                    <p className="report-message">{report.message}</p>
                                    <p className={`report-status ${report.status === 'read' ? 'read' : 'unread'}`}>
                                        {report.status.charAt(0).toUpperCase() + report.status.slice(1)}
                                    </p>
                                    {report.reply && (
                                        <div className="admin-reply">
                                            <h5>Admin Reply:</h5>
                                            <p>{report.reply}</p>
                                        </div>
                                    )}
                                    <p className="report-date">
                                        Submitted on: {new Date(report.created_at).toLocaleString()}
                                    </p>
                                </li>
                            ))}
                        </ul>
                    )}
                </>
            )}
        </div>
    );
};

export default UserReports;
